import { render } from "./TemplatePanel.vue?vue&type=template&id=a8d8c078&scoped=true"
import script from "./TemplatePanel.vue?vue&type=script&lang=js"
export * from "./TemplatePanel.vue?vue&type=script&lang=js"

import "./TemplatePanel.vue?vue&type=style&index=0&id=a8d8c078&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8d8c078"]])

export default __exports__